export default __webpack_public_path__ + "static/media/446.f4920909.gif";